var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{staticClass:"float-left",staticStyle:{"max-width":"800px"},attrs:{"title":"人气","img-src":"http://stock.ziruxing.com/robot/static/manual.png","img-alt":"Image","img-top":"","tag":"article"}},[_c('b-card-text',[_vm._v(" 如图 ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }